export type CourseTypes = "self_paced" | "scheduled" | "structured";

export const COURSE_TYPES = {
  self_paced: "self_paced",
  scheduled: "scheduled",
  structured: "structured",
} as const;

export const DEFAULT_COURSE_TYPE = COURSE_TYPES.self_paced;
